import { render, staticRenderFns } from "./PeriodSales.vue?vue&type=template&id=033840bc&scoped=true&"
import script from "./PeriodSales.vue?vue&type=script&lang=ts&"
export * from "./PeriodSales.vue?vue&type=script&lang=ts&"
import style0 from "./PeriodSales.vue?vue&type=style&index=0&id=033840bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033840bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
